const pageNameKey = "scanInterruptionModal";

export const scanInterruptionModalEn = {
  [pageNameKey]: {
    modalSubHeader: "Warning",
    reallyCancelScanQuestion: "Really Cancel Scan?",
    allConnectionsWillBeLostWarning: "All new connections will be lost.",
    yesButton: "Yes",
    noButton: "No",
  },
};

export const scanInterruptionModalPtBr = {
  [pageNameKey]: {
    modalSubHeader: "Aviso",
    reallyCancelScanQuestion: "Cancelar a verificação mesmo?",
    allConnectionsWillBeLostWarning: "Todas as novas conexões serão perdidas.",
    yesButton: "Sim",
    noButton: "Não",
  },
};

export const scanInterruptionModalDe = {
  [pageNameKey]: {
    modalSubHeader: "Warnung",
    reallyCancelScanQuestion: "Scan wirklich abbrechen?",
    allConnectionsWillBeLostWarning: "Alle neuen Verbindungen gehen verloren.",
    yesButton: "Ja",
    noButton: "Nein",
  },
};

export const scanInterruptionModalZhHans = {
  [pageNameKey]: {
    modalSubHeader: "警告",
    reallyCancelScanQuestion: "真的要取消扫描吗？",
    allConnectionsWillBeLostWarning: "所有新连接将丢失。",
    yesButton: "是",
    noButton: "否",
  },
};

export const scanInterruptionModalIt = {
  [pageNameKey]: {
    modalSubHeader: "Avviso",
    reallyCancelScanQuestion: "Vuoi veramente annullare la scansione?",
    allConnectionsWillBeLostWarning:
      "Tutte le nuove connessioni andranno perse.",
    yesButton: "Sì",
    noButton: "No",
  },
};

export const scanInterruptionModalEs = {
  [pageNameKey]: {
    modalSubHeader: "Advertencia",
    reallyCancelScanQuestion: "¿Realmente cancelar el escaneo?",
    allConnectionsWillBeLostWarning: "Se perderán todas las conexiones nuevas.",
    yesButton: "Sí",
    noButton: "No",
  },
};

export const scanInterruptionModalNl = {
  [pageNameKey]: {
    allConnectionsWillBeLostWarning: "Alle nieuwe verbindingen gaan verloren.",
    modalSubHeader: "Waarschuwing",
    noButton: "Nee",
    reallyCancelScanQuestion: "Scan echt annuleren?",
    yesButton: "Ja",
  },
};

export const scanInterruptionModalTr = {
  [pageNameKey]: {
    allConnectionsWillBeLostWarning: "Tüm yeni bağlantılar kaybolacak.",
    modalSubHeader: "Uyarı",
    noButton: "HAYIR",
    reallyCancelScanQuestion: "Tarama Gerçekten İptal Edilsin mi?",
    yesButton: "Evet",
  },
};
